// extracted by mini-css-extract-plugin
export var ModalThumb = "buero-module--ModalThumb--w0w8O";
export var ModalThumbContainer = "buero-module--ModalThumbContainer--xax-Q";
export var TriggerZoneLeft = "buero-module--TriggerZoneLeft--Iuzow";
export var TriggerZoneRight = "buero-module--TriggerZoneRight--HK+kp";
export var InfoZoneLeft = "buero-module--InfoZoneLeft--meo2H";
export var InfoZoneRight = "buero-module--InfoZoneRight--Xt0xl";
export var Visible = "buero-module--Visible--WUiQr";
export var Thumb = "buero-module--Thumb--G4zg-";
export var ThumbContainer = "buero-module--ThumbContainer--UUTll";